module.exports = __webpack_public_path__ + "media/assets/images/wallpapers/san_marco_wallpaper_full-617fa0895673ff3243ba6549d4c7ae09.png";